import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { cn } from "styles/utils"

const ProductDescription = ({ productName }) => {
  const collectionReviewExp = useSelector(
    (state) => state.experiment.collectionReview.variant_id
  )

  return (
    <p
      className={cn(
        "desktop:line-clamp-1 text-ellipsis",
        collectionReviewExp === 1
          ? "body leading-18 widescreen:leading-20 desktop:h-18 widescreen:h-20 mb-8 line-clamp-2 h-36"
          : "text-18 leading-20 mb-10 mt-6 hidden h-20 px-16"
      )}
      title={productName}
    >
      {productName}
    </p>
  )
}

ProductDescription.propTypes = {
  productName: PropTypes.string,
}

export default ProductDescription
